<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card flat>
          <v-card-text>
            <p align="center">
              <strong><u>ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ</u></strong>
            </p>
            <p align="center">
              Политика за поверителност и сигурност на личните данни, предоставени за
              обработка на АРТИКЕТ EООД, ЕИК: 205660717, през интернет адрес
              www.articket.eu
            </p>
            <p>
              В сила от: 22.08.19 г.
            </p>
            <p>
              Уважаеми клиенти,
            </p>
            <p>
              Публикуваме на Вашето внимание съдържащите се в текста по-долу уведомления,
              които описват в какъв контекст обработваме Вашите лични данни и обясняват
              Вашите права, както и нашите задължения, във връзка с обработването на
              личните Ви данни. В настоящата Политика за поверителност, „ние” или „нас”
              се отнася до АРТИКЕТ EООД, ЕИК: 205660717.
            </p>
            <p>
              АРТИКЕТ EООД, ЕИК: 205660717 е дружество, със седалище и адрес на
              управление в гр. София, район Триадица, ж.к. Гоце Делчев, бл. 254, вх. Б,
              ет. 1. Като администратор на личните Ви данни ние носим отговорност за
              обработването на личната Ви информация на настоящия интернет адрес. Ако
              имате въпроси, свързани с използването на Вашите лични данни съгласно
              настоящата Политика за поверителност, моля свържете се нас на е-mail    <a href="mailto:myrights@articket.eu">myrights@articket.eu</a>, или на
              адрес: гр. София, район Триадица, ж.к. Гоце Делчев, бл. 254, вх. Б, ет. 1.
            </p>
            <p>
              Моля да имате предвид и че Комисията за защита на личните данни (КЗЛД) е
              постоянно действащ независим държавен надзорен орган, който осъществява
              защитата на лицата при обработването на техните лични данни и при
              осъществяването на достъпа до тези данни, както и контрола по спазването на
              действащото българско и европейско законодателство в областта на защитата
              на личните данни. Допълнителна информация можете да намерите на интернет
              адрес <a href="http://www.cpdp.bg">www.cpdp.bg</a>
            </p>
            <p>
              АРТИКЕТ EООД се стреми да осъществява дейността по обработване на личните
              Ви данни при пълно спазване на изискванията на Закона за защита на личните
              данни и на Регламент (ЕС) 2016/679 на Европейския парламент и на Съвета
              относно защитата на физическите лица във връзка с обработването на лични
              данни и относно свободното движение на такива данни (Общ регламент за
              защита на данните).
            </p>
            <p>
              Настоящата Политика за защита на личните данни е изготвена и се основава на
              действащото българско и европейско законодателство в областта на защитата
              на личните данни.
            </p>
            <p>
              Моля да имате предвид, че си запазваме правото да актуализираме настоящата
              Политика за поверителност, като съответната обновена версия ще бъде
              публикувана на Вашето внимание на този интернет адрес.
            </p>
            <p align="center">
              РАЗДЕЛ I
            </p>
            <p align="center">
              Лични данни, които обработваме
            </p>
            <p>
              При посещение на нашия интернет адрес за получаване на допълнителна
              информация за предлаганите от нас услуги и продукти не е необходима никаква
              форма на регистрация, което Ви дава възможност да посещавате настоящия
              интернет адрес, без да ни информирате кой сте. За някои услуги обаче може
              да е необходимо да ни предоставите Ваши лични данни, като например името
              Ви, електронен адрес за комуникация (e-mail) с Вас, Ваш телефонен номер и
              др.
            </p>
            <p>
              Може да събираме от Вас различни видове лични данни, включително:
            </p>
            <p>
              <strong>1. </strong>
              Данни, свързани с изразени от Вас предпочитания:
            </p>
            <p>
              1.1. Лични данни, предоставени от вас с цел анализ потреблението Ви на
              настоящия интернет адрес, както и с цел персонализиране на нашите оферти
              към Вас и осигуряване на предложения за най-подходящите продукти или
              услуги, които биха представлявали интерес за Вас;
            </p>
            <p>
              1.2. Лични данни, получени от взаимодействие помежду ни, чрез посетени от
              Вас обекти с предоставени от нас продукти и услуги; наши интернет страници
              и страници в социалните мрежи; срещи; обаждания; комуникация през
              електронна поща и др.;
            </p>
            <p>
              <strong>2. </strong>
              При закупуване на билет от нас Вие ни предоставяте следната
              идентификационна информация и информация за връзка и контакт:
            </p>
            <p>
              2.1.Имена по документ за самоличност;
            </p>
            <p>
              2.2.Адрес на Ваша електронна поща;
            </p>
            <p>
              2.3.Телефон за връзка с Вас;
            </p>
            <p>
              2.4.Данни за извършване на плащането - когато предпочитаната опция за
              плащане е плащане с банкова карта.
            </p>
            <p align="center">
              РАЗДЕЛ II
            </p>
            <p align="center">
              Цели за обработка на лични данни
            </p>
            <p>
              Възможно е да събираме и използваме личните Ви данни, за да Ви предоставим
              продукти или услуги, да фактурираме тези продукти и услуги, за да изпълним
              нормативните си задължения по приложимото законодателство, както и да Ви
              предлагаме продукти и услуги, които считаме, че могат да представляват
              интерес за Вас (когато са изпълнени законовите предпоставки за това), или
              за да комуникираме с Вас с друга цел, която е видна от обстоятелствата или
              за която Ви информираме при събирането на личните Ви данни. Основанията,
              въз основа на които най-често обработваме личните Ви данни са вашето
              съгласие, изпълнението на договор, по който сте страна, изпълнение на
              законово задължение или за целите на легитимните интереси на АРТИКЕТ EООД,
              включително:
            </p>
            <p>
              <strong>1. </strong>
              Със закупуването на билет от нас между Вас и нас се сключва договор за
              продажба на билет/и за предстоящо мероприятие. В тази връзка целта на
              събирането и обработката на доброволно предоставените от Вас лични данни е
              да се приведе в изпълнение сключеният договор. Предоставените данни за
              контакт целят да спомогнат комуникацията помежду ни във връзка с
              изпращането/получаването на закупения от Вас билет/и, както и за уточняване
              на последващи обстоятелства, при евентуално тяхно възникване, които имат
              отношение към изпълнението на сключения между нас договор. Също така
              предоставените от Вас данни за контакт целят да спомогнат комуникацията при
              получаване, разглеждане и обработка на Ваше искане/жалба или такова от
              оправомощен държавен/публичен/съдебен орган;
            </p>
            <p>
              <strong>2. </strong>
              Предоставените от Вас лични данни се обработват от нас с цел удостоверяване
              на съгласието Ви за тяхната обработка, съгласно изискванията на приложимото
              национално законодателство;
            </p>
            <p>
              <strong>3. </strong>
              Предоставените от Вас лични данни се обработват от нас с цел предприемане
              на мерки свързани със санкции/ембарго, мерките за предотвратяване
              изпирането на пари, финансирането на тероризма, данъчни измами, контрол,
              изисквания за данъчно облагане и счетоводни задължения;
            </p>
            <p>
              <strong>4. </strong>
              Възможно е да събираме и обработваме информация за посещенията Ви на този
              интернет адрес, например, страниците, които посещавате, интернет адреса,
              през който достъпвате, и някои от търсенията, които извършвате. Ние
              използваме тази информация, за да подобрим съдържанието на интернет адреса
              ни и да съберем обобщена статистика за лицата, които ползват уебсайта ни,
              за вътрешни цели, във връзка с прочуването на пазара. В този процес е
              възможно да инсталираме „бисквитки“, които събират информация за
              наименованието на домейна на потребителя, Вашия доставчик на интернет
              услуги, операционната Ви система, както и датата и часа на достъп.
              „Бисквитка“ е малък информационен елемент, изпращан до браузъра Ви и
              съхраняван в твърдия диск на компютъра Ви. Бисквитките не увреждат
              компютъра Ви. Можете да настроите браузъра си да Ви уведомява, когато
              получите „бисквитка“, което ще Ви позволи да решите дали искате да я
              приемете или не. Имате възможност и изцяло да се откажете да получавате
              бисквитки. Ако обаче не приемете бисквитките, няма да можете да ползвате
              пълната функционалност на софтуера на браузъра Ви, както и на нашия
              интернет адрес.
            </p>
            <p>
              <strong>5. </strong>
              Предоставените от Вас лични данни се обработват от нас с цел да
              персонализираме нашите оферти към Вас и да Ви осигурим най-подходящите
              продукти или услуги, които биха представлявали интерес за Вас.
            </p>
            <p>
              Всяко изпълнение на наше законово задължение, което не е посочено в
              настоящата Политика за поверителност, не съставлява неизпълнение на
              задълженията ни, съгласно посочените цели.
            </p>
            <p align="center">
              РАЗДЕЛ III
            </p>
            <p align="center">
              Период на обработка на лични данни
            </p>
            <p>
              Ние ще запазим Вашите лични данни за период от време, който е необходим за
              спазване на приложимите закони и подзаконови нормативни актове, за
              изпълнение на нашите договорни взаимоотношения с Вас, като, но не само НОИ,
              в съответствие с оперативните изисквания и улесняване на управлението на
              взаимоотношенията с клиентите. В случай, че имате конкретно запитване за
              срока на съхраняване на предоставени от Вас лични данни моля свържете се с
              нас чрез е-mail    <a href="mailto:myrights@articket.eu">myrights@articket.eu</a>, или на
              адрес: гр. София, район Триадица, ж.к. Гоце Делчев, бл. 254, вх. Б, ет. 1 и
              ние ще ви дадем по-детайлна и конкретна информация с оглед на спецификата
              на конкретното запитване.
            </p>
            <p align="center">
              РАЗДЕЛ IV
            </p>
            <p align="center">
              Правно основание за обработка на лични данни
            </p>
            <p>
              Обработката на предоставените от Вас лични данни се основава и осъществява
              при пълното спазване на изискванията на Закона за защита на личните данни и
              на Регламент (ЕС) 2016/679 на Европейския парламент и на Съвета относно
              защитата на физическите лица във връзка с обработването на лични данни и
              относно свободното движение на такива данни (Общ регламент за защита на
              данните), както и на основание встъпването в и изпълнението на договорно
              взаимоотношение с Вас по повод покупката на билет/и за мероприятие. В хода
              на изпълнение на наши законови права и задължения, свързани, но не само,
              със задължения за отчетност и предоставяне на информация за извършваната от
              нас дейност пред държавни органи е правно основание в допълнение към
              горепосочените в настоящия раздел, на базата на което обработваме
              предоставените от Вас лични данни. И не на последно място правно основание
              за обработката на тези данни е удостоверяване на съгласието Ви за тяхната
              обработка, съгласно изискванията на приложимото национално законодателство.
            </p>
            <p align="center">
              РАЗДЕЛ V
            </p>
            <p align="center">
              Други лица, получаващи информация за предоставените лични данни
            </p>
            <p>
              Може да предоставим достъп до и да разкрием Ваша лична информация, при
              условията на конфиденциалност, и само доколкото е необходимо за
              осъществяване и обезпечаване на нашата дейност, задължения и/или
              горепосочените цели, само на:
            </p>
            <p>
              <strong>1. </strong>
              Служители на АРТИКЕТ EООД, длъжностните характеристики на които са свързани
              с изпълнение на задължение по обработка на сключените договори за покупка
              на билет/и, както и трети лица (доставчиците на платежни услуги и/или
              организатори на определено събитие, но не само), ангажирани в изпълнението
              на договора или за друг предлаган от нас продукт или услуга;
            </p>
            <p>
              <strong>2. </strong>
              Финансови/съдебни/правоприлагащи органи/държавни органи или агенции, при
              поискване или в изпълнение на наш интерес или задължение, когато смятаме,
              че е уместно да се приложи или сме задължени, дори, когато имаме
              добросъвестно убеждение, че сме длъжни да спазваме закона, в степента,
              разрешена от закона;
            </p>
            <p>
              <strong>3. </strong>
              Лица с определени от закона права и задължения, включително: адвокати,
              нотариуси, държавни/частни съдебни изпълнители, одитори и т.н.
            </p>
            <p align="center">
              РАЗДЕЛ VI
            </p>
            <p align="center">
              Трансфериране на данни извън Европейско икономическо пространство
            </p>
            <p>
              В случай на международни преводи, произхождащи от Европейското икономическо
              пространство (ЕИП), когато Европейската комисия (ЕК) е признала държава
              извън ЕИП като осигуряваща адекватно ниво на защита на данните, вашите
              лични данни ще бъдат прехвърлени на това основание. За трансфери до страни
              извън ЕИП, чието ниво на защита не е призната от ЕК, ние ще се позовем на
              дерогация, приложима към конкретната ситуация (напр. ако прехвърлянето е
              необходимо във връзка с изпълнение на договора ни с вас) или ще приложим
              една от следните гаранции, за да гарантираме защитата на личните Ви данни:
              Стандартни договорни клаузи, одобрени от ЕК или Обвързващи корпоративни
              правила с наши контрагенти.
            </p>
            <p align="center">
              РАЗДЕЛ VII
            </p>
            <p align="center">
              Права на клиентите за защита на личните данни и начин на упражняването им
            </p>
            <p>
              В съответствие с приложимите законови разпоредби имате следните права:
            </p>
            <p>
              <strong>1. </strong>
              Правото на достъп: можете да получите информация, свързана с обработката на
              Вашите лични данни, както и копие от такива лични данни;
            </p>
            <p>
              <strong>2. </strong>
              Право на коригиране: когато считате, че Вашите лични данни са неточни или
              непълни, можете да поискате такива лични данни да бъдат съответно
              променени;
            </p>
            <p>
              <strong>3. </strong>
              Правото на изтриване: можете да поискате изтриването на личните Ви данни,
              доколкото не съществуват законни основания за тяхното съхранение;
            </p>
            <p>
              <strong>4. </strong>
              Правото на ограничаване: можете да поискате ограничаване на обработката на
              Вашите лични данни;
            </p>
            <p>
              <strong>5. </strong>
              Правото на възражение: можете да възразите срещу обработването на личните
              Ви данни на основания, свързани с конкретната Ви ситуация. Имате абсолютно
              право да се противопоставите на обработването на личните Ви данни за целите
              на директния маркетинг, което включва профилиране, свързано с такъв
              директен маркетинг;
            </p>
            <p>
              <strong>6. </strong>
              Правото да оттеглите вашето съгласие: когато сте дали съгласието си за
              обработка на Вашите лични данни, имате право да го оттеглите по всяко
              време. Оттеглянето на съгласието не засяга законосъобразността на
              обработването на данните на субекта, основано на даденото от него съгласие
              преди оттегляне му и на обработка основаваща се на друго правно основание;
            </p>
            <p>
              <strong>7. </strong>
              Правото на преносимост на данни: когато имаме законово основание и е
              технически осъществимо, данните Ви може да бъдат прехвърлени на трета
              страна;
            </p>
            <p>
              <strong>8. </strong>
              Правото да подадете жалба до компетентния надзорен орган - Комисия за
              защита на личните данни, на интернет адрес    <a href="http://www.cpdp.bg">www.cpdp.bg</a>
            </p>
            <p>
              Ако искате да упражнявате посочените по-горе права, моля изпратете писмо
              или искане по електронна поща на следния адрес: гр. София, район Триадица,
              ж.к. Гоце Делчев, бл. 254, вх. Б, ет. 1 и/или на е-mail    <a href="mailto:myrights@articket.eu">myrights@articket.eu</a>. Моля,
              имайте предвид, че може да е необходима допълнителна проверка за Вашата
              идентификация. Ние ще отговорим на Вашето искане в най-кратък възможен срок
              и не по-късно от 30 дни от неговото получаване.
            </p>
            <p>
              Също така имате право да подадете жалба до Комисия за зашита на личните
              данни, когато са налице съответните предпоставки за това.
            </p>
            <p align="center">
              РАЗДЕЛ VIII
            </p>
            <p align="center">
              Контакт с нас
            </p>
            <p>
              Ако имате въпроси, свързани с използването на Вашите лични данни съгласно
              настоящото Политика за поверителност, моля свържете се с нас на е-mail    <a href="mailto:myrights@articket.eu">myrights@articket.eu</a>, или на
              адрес: гр. София, район Триадица, ж.к. Гоце Делчев, бл. 254, вх. Б, ет. 1
            </p>
            <p>
              Дата на последна актуализация: 22.08.19 г.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
	export default {
		name: '',
		components: {},
		mixins: [],
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		mounted() {
		},
		methods: {}
	}
</script>

<style></style>
